import React from "react";


import { CardHeader, CardHeaderProps, Divider } from '@material-ui/core';

export interface CustomCardHeaderProps extends CardHeaderProps {
  ShowDivider?: boolean
}

export default function CustomCardHeader(props: CustomCardHeaderProps) {

  const { title, children, ShowDivider = true, ...rest } = props

  return (
    <>

      <CardHeader
        title={title || children}
        style={{ "textAlign": "center" }}
        {...rest}
      >

      </CardHeader>
      {ShowDivider && <Divider />}

    </>
  );
}

